import url from 'url'
import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const CSV_EXPORT_REQUEST = 'CSV_EXPORT_REQUEST'
export const CSV_EXPORT_SUCCESS = 'CSV_EXPORT_SUCCESS'
export const CSV_EXPORT_FAILURE = 'CSV_EXPORT_FAILURE'
export const CSV_EXPORT_RESET = 'CSV_EXPORT_RESET'

const reset = () => ({
  type: CSV_EXPORT_RESET,
})

export const resetCSVExport = () => (dispatch) => dispatch(reset())

export const fetchCSVDataset = (requestUrl, pageSize = null) => {
  let endpoint = requestUrl
  if (pageSize) {
    const urlObj = url.parse(requestUrl, true)
    if (urlObj.query && urlObj.query.hasOwnProperty('page')) {
      const currentQuery = urlObj.query
      let queryParams = {}
      if (urlObj.query.page === '1') {
        queryParams = { ...currentQuery, ...{ page_size: pageSize } }
      } else {
        queryParams = { ...currentQuery, ...{ page: '1', page_size: pageSize } }
      }
      endpoint = buildUrl(requestUrl, { ...queryParams })
    } else {
      let queryParams = {}
      queryParams = { page: '1', page_size: pageSize }
      endpoint = buildUrl(requestUrl, { ...queryParams })
    }
  }

  return {
    [CALL_API]: {
      endpoint,
      types: [CSV_EXPORT_REQUEST, CSV_EXPORT_SUCCESS, CSV_EXPORT_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
